import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme/semanticTokens';
import { Typography } from '../../../Typography';

export interface InputHelpTextProps {
  className?: string;
  text: string;
  hasError?: boolean;
}

const StyledHelpText = styled(Typography)<{ $hasError: boolean }>`
  color: ${({ $hasError }) =>
    $hasError
      ? theme.dime.colors.text.critical
      : theme.dime.colors.text.secondary};
  margin-bottom: ${theme.dime.spacing.s};
`;

export const InputHelpText: React.FC<InputHelpTextProps> = ({
  className,
  text,
  hasError = false
}) => (
  <StyledHelpText className={className} variant="body1" $hasError={hasError}>
    {text}
  </StyledHelpText>
);
